import { getRouteApi } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'

const routeApi = getRouteApi('/_app/bsa/sars/$id/edit')

export const useRouting = () => {
  const { returnUrl } = routeApi.useSearch()
  const navigate = routeApi.useNavigate()
  const params = routeApi.useParams()
  const id = +(params.id || 0)

  const comeBackToDetailsOrReturnUrl = () => {
    if (returnUrl) {
      navigate({ to: decodeURIComponent(returnUrl) })
    } else {
      if (id) {
        navigate({ to: routes.bank.bsa.sar.details, params: { id: id.toString() } })
      } else {
        navigate({ to: routes.bank.bsa.sar.index })
      }
    }
  }

  return {
    id,
    comeBackToDetailsOrReturnUrl
  }
}
